module.exports = {
	"id": "SL",
	"name": "Sierra Leone",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02113,
			"12": 0.016904,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.002113,
			"25": null,
			"26": 0.059164,
			"27": null,
			"28": null,
			"29": 0.052825,
			"30": 0.002113,
			"31": 0.006339,
			"32": 0.006339,
			"33": 0.014791,
			"34": 0.006339,
			"35": 0.002113,
			"36": 0.006339,
			"37": null,
			"38": 0.004226,
			"39": 0.004226,
			"40": null,
			"41": null,
			"42": 0.016904,
			"43": 0.367662,
			"44": 0.023243,
			"45": 0.16904,
			"46": 0.035921,
			"47": 0.059164,
			"48": 0.038034,
			"49": 0.145797,
			"50": 0.027469,
			"51": 0.834635,
			"52": 0.194396,
			"53": 5.555077,
			"54": 1.41571,
			"55": 0.033808,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.012678,
			"4": 0.031695,
			"5": 0.008452,
			"6": 0.012678,
			"7": 0.016904,
			"8": 0.006339,
			"9": null,
			"10": 0.027469,
			"11": 0.016904,
			"12": 0.050712,
			"13": 0.040147,
			"14": 0.016904,
			"15": 0.004226,
			"16": 0.019017,
			"17": 0.006339,
			"18": 0.010565,
			"19": 0.050712,
			"20": 0.016904,
			"21": 0.014791,
			"22": 0.029582,
			"23": 0.031695,
			"24": 0.014791,
			"25": 0.06339,
			"26": 0.019017,
			"27": 0.004226,
			"28": null,
			"29": 0.023243,
			"30": 0.025356,
			"31": 0.04226,
			"32": 0.023243,
			"33": 0.035921,
			"34": 0.014791,
			"35": 0.010565,
			"36": 0.012678,
			"37": 0.006339,
			"38": 0.02113,
			"39": 0.088746,
			"40": 0.023243,
			"41": 0.095085,
			"42": 0.016904,
			"43": 0.257786,
			"44": 0.183831,
			"45": 0.069729,
			"46": 0.08452,
			"47": 0.568397,
			"48": 0.606431,
			"49": 3.10611,
			"50": 0.750115,
			"51": null,
			"52": null,
			"3.5": 0.010565,
			"3.6": 0.014791
		},
		"opera": {
			"9": null,
			"11": 0.014791,
			"12": 0.004226,
			"15": 0.004226,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.002113,
			"25": null,
			"26": null,
			"27": 0.010565,
			"28": null,
			"29": 0.025356,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.006339,
			"34": 0.010565,
			"35": 0.004226,
			"36": 0.006339,
			"37": 0.052825,
			"38": 0.016904,
			"39": 0.069729,
			"40": 0.407809,
			"41": 0.065503,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.004226,
			"11.6": 0.016904,
			"12.1": 0.016904
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.004226,
			"7": 0.008452,
			"8": 0.019017,
			"9": 0.114102,
			"10": 0.395131,
			"3.1": null,
			"3.2": null,
			"5.1": 0.016904,
			"6.1": null,
			"7.1": null,
			"9.1": 0.073955
		},
		"ios_saf": {
			"8": 0,
			"10": 1.19152803247,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0321103017277,
			"8.1-8.4": 0.059322421836,
			"9.0-9.2": 0.0283006049126,
			"9.3": 0.431765639051
		},
		"android": {
			"3": 0,
			"4": 0.0382325891473,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00477907364341,
			"4.1": 0.137910410853,
			"4.2-4.3": 0.344776027132,
			"4.4": 0.790595325581,
			"4.4.3-4.4.4": 0.797422573643
		},
		"ie": {
			"6": null,
			"7": 0.0042347950052,
			"8": 0.254087700312,
			"9": 0.0698741175858,
			"10": 0.124926452653,
			"11": 1.49276523933,
			"5.5": null
		},
		"op_mob": {
			"0": 4.14077451947,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.11502151443
		},
		"edge": {
			"12": 0.160588,
			"13": 0.266238,
			"14": 0.331741
		},
		"ie_mob": {
			"10": 0.0886454366197,
			"11": 0.36091356338
		},
		"bb": {
			"7": 0.0197175,
			"10": null
		},
		"samsung": {
			"0": 1.238259
		},
		"and_uc": {
			"0": 5.978346
		},
		"op_mini": {
			"0": 55.7879349661
		},
		"and_chr": {
			"0": 7.159963
		},
		"and_ff": {
			"0": 0.007887
		}
	},
	"total": 98.5697348049
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SL.json
 ** module id = 646
 ** module chunks = 0
 **/